
<label for="drawer-control" class="drawer-toggle persistent" />



<input type="checkbox" id="drawer-control" class="drawer persistent" />
<div>
    <label for="drawer-control" class="drawer-close" />
    <br />
    <a href="/">Home</a>
    <br />
    <a href="/admin">Amministrazione</a><br />
</div>